import { create } from 'zustand';
import {
  BuyCreditStore,
  DetailsTransactionsViewMode,
  IDetailsTransactionsSwitch,
  IShowInstallBanner,
} from './interface';

export const useDetailsTransactionsSwitch = create<IDetailsTransactionsSwitch>((set) => ({
  viewMode: DetailsTransactionsViewMode.Details,
  setViewMode: (viewMode) => {
    set({ viewMode: viewMode });
  },
}));
export const useIsShowInstallBanner = create<IShowInstallBanner>((set) => ({
  IsShowInstallBanner: false,
  setIsShowInstallBanner: (data) => {
    set({ IsShowInstallBanner: data });
  },
}));

export const useBuyCreditStore = create<BuyCreditStore>((set) => ({
  activeTab: 'rialBashgah',
  setActiveTab: (tab) => set({ activeTab: tab }),
}));
